import { render, staticRenderFns } from "./Covid-19.vue?vue&type=template&id=f030a22a&scoped=true&"
import script from "./Covid-19.vue?vue&type=script&lang=js&"
export * from "./Covid-19.vue?vue&type=script&lang=js&"
import style0 from "./Covid-19.vue?vue&type=style&index=0&id=f030a22a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f030a22a",
  null
  
)

export default component.exports